import React from 'react'
import PropTypes from 'prop-types'
import { mdiCheck } from '@mdi/js'
import 'core-js/features/array/find'
import { Icon } from '@jcu/cookbook-react'

import { Button, Row, Col } from 'react-bootstrap'
import { createOrcidLinkHandler } from '../lib/orcid'

const SCOPES = ['/read-limited', '/person/update', '/activities/update']

const OrcidPermission = ({ scope, tokens, unlinkOrcid }) => {
  const matchedToken = tokens && tokens.find(token => token.scope === scope)

  const handleOrcidUnlink = event => {
    event.preventDefault()
    unlinkOrcid(matchedToken)
  }

  const [permission, reason] = (scope => {
    /* eslint-disable default-case */
    switch (scope) {
      case '/read-limited':
        return [
          'Read your limited-access information',
          'Allows JCU to read content from your ORCID record for use in university systems and services',
        ]
      case '/person/update':
        return [
          'Add or update your biographical information',
          'Update your ORCID record with URLs, names, external IDs, biographical info and other personal details',
        ]
      case '/activities/update':
        return [
          'Add or update your research activities',
          'Update your ORCID record with funding, works/publications, employment, education and similar details',
        ]
    }
    /* eslint-enable default-case */
  })(scope)

  return (
    <li className="py-2 px-1 list-group-item">
      <Row xs={12} className="align-items-center gy-2 gy-sm-0">
        <Col>
          {matchedToken && (
            <Icon
              style={{ verticalAlign: 'middle' }}
              path={mdiCheck}
              size="1.5rem"
              title="Linked!"
              color="008a00"
            />
          )}{' '}
          {permission}
          <br />
          <span className="small text-muted">{reason}</span>
        </Col>
        <Col className="d-grid" sm={3} md={2}>
          {matchedToken ? (
            <Button variant="danger" onClick={handleOrcidUnlink}>
              Disconnect
            </Button>
          ) : (
            <Button
              onClick={createOrcidLinkHandler({
                queryString: 'scope=' + scope,
              })}
            >
              Connect
            </Button>
          )}
        </Col>
      </Row>
    </li>
  )
}

OrcidPermission.propTypes = {
  scope: PropTypes.oneOf(SCOPES).isRequired,
  tokens: PropTypes.array.isRequired,
  unlinkOrcid: PropTypes.func.isRequired,
}

OrcidPermission.scopes = SCOPES

export default OrcidPermission
